
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
 export const notifySave = () => {
    toast.success("Timesheet Save Successful", {
   position: toast.POSITION.TOP_CENTER,
   autoClose: 2000 
 });
}

 export const notifySubmit = () => {
     toast.success("Timesheet Submit Successful", {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 2000 
  });
}

export const notifyAttachmentDel = () => {
    toast.info("Attachment deleted successfully.!", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000 
    });
}

export const notifyAttachment = () => {
    toast.success("Attachment updated successfully.", {
  position: toast.POSITION.TOP_CENTER,
  autoClose: 2000 
});
}

export const notifyComfirDel = () => {
    toast.warn("Warning! Are you sure want to delete the file?", {
      position: toast.POSITION.TOP_CENTER,
      closeOnClick: true,
      autoClose: 2000 
    });
}

export const notifySuccess = () => {
    toast.success("Info!", {
  position: toast.POSITION.TOP_CENTER,
  autoClose: 2000 
});
}

export const notifyError = () => {
    toast.error("Info!", {
  position: toast.POSITION.TOP_CENTER,
  autoClose: false
});
}
    

export const notifyWarning = () => {
    toast.warn("Warning!", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: false
    });
}
export const notifyInfo = () => {
        toast.toast.Info("Info!", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: false
    });
}
export const notify = (type,message) => {
  const _position={
    position: toast.POSITION.TOP_CENTER
    }
    switch(type){
      case 'error':
            toast.error(message,_position);
          break;
        case 'success':
            toast.success(message,_position);
          break;
          case 'warning':
            toast.warn(message,_position);
          break;
          default:
              toast.info(message,_position);
            break;
    }
}
// // return <button onClick={notify}>Notify</button>;
